export default __webpack_public_path__ + "static/media/blob_5-3-5.b14dae6d.svg";